module.exports = __webpack_public_path__ + "img/advanced.547438ea.svg";